import { Injectable } from '@angular/core';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';

@Injectable({
  providedIn: 'root',
})
export class SecureStorageService {
  constructor() {}

  async setSecureStorageData(key: string, token: string): Promise<void> {
    await SecureStoragePlugin.set({
      key: key,
      value: token,
    });
  }

  async getSecureStorageData(key: string): Promise<string | null> {
    try {
      const result = await SecureStoragePlugin.get({ key: key });
      return result.value;
    } catch (error) {
      return null;
    }
  }

  async removeSecureStorageData(key: string): Promise<void> {
    await SecureStoragePlugin.remove({ key: key });
  }
}